export const frameSizeConst = [
    {
      id: 0,
      title: 'Extra Small',
      short: 'XS',
      slug: 'extra-small',
    },
    {
      id: 1,
      title: 'Small',
      short: 'S',
      slug: 'small',
    },
    {
      id: 2,
      title: 'Medium',
      short: 'M',
      slug: 'medium',
    },
    {
      id: 3,
      title: 'Large',
      short: 'L',
      slug: 'large',
    }
  ];